import { SelectOption } from '@fly/core';
import { UserRole } from '@fly/shared';
import type { TFunction } from 'i18next';

export const getUserRolesOptions = (t: TFunction): SelectOption[] => [
  {
    value: UserRole.ADMIN.toString(),
    textValue: t(
      `app.dashboard.team_management.columns.role_options.${UserRole.ADMIN}`,
      { defaultValue: 'Admin' }
    ),
  },
  {
    value: UserRole.DEVELOPER.toString(),
    textValue: t(
      `app.dashboard.team_management.columns.role_options.${UserRole.DEVELOPER}`,
      { defaultValue: 'Developer' }
    ),
  },
];
